import { AdsapceButtons, AdsapceStatus, AdspaceName, IAdspace } from 'entities/Adspace';

export const getAdspace = (adspace: Partial<IAdspace>, key: number) => {
	const { status } = adspace;

	return {
		key,
		name: <AdspaceName adspace={adspace} />,
		status: <AdsapceStatus adspaceStatus={status} />,
		buttons: <AdsapceButtons adspace={adspace} />,
	};
};
